import { render, staticRenderFns } from "./PaymentSuccessHeader.vue?vue&type=template&id=54bc32d5&scoped=true&"
import script from "./PaymentSuccessHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccessHeader.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSuccessHeader.vue?vue&type=style&index=0&id=54bc32d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc32d5",
  null
  
)

export default component.exports